














































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { getAppUrl } from '@/api/http-constants'
import { UserModule } from '@/store/modules/user'
import router from '../router'
import { getBoUrl } from '../api/http-constants'
import { ApiService } from '@/api/api.service'
import Notifications from '@/components/Notifications.vue'
import cloneDeep from 'lodash/cloneDeep'
import take from 'lodash/take'
import { NotificationsModule } from '@/store/modules/notifications'
import { getOperationID, getOperation } from '@/api/operations'

import { nickname } from '@/utils/nickname'
import ProfilMenu from '@/components/ProfilMenu.vue'
import Avatar from '@/components/Profil/Avatar.vue'

@Component({
    components: {
        Notifications,
        ProfilMenu,
        Avatar,
    },
})
export default class Header extends Vue {
    apiService = new ApiService()
    userID: number = 0
    name = ''
    headerActive = false
    menuTop = 0
    windowHeight = 0
    allOpe = []
    opeID: number
    opeSelected = null
    ope: any = null
    settings = {
        copyClassesToDropdown: false,
        maxItems: 1,
        create: false,
    }
    $notificationsDropdown = null
    notificationsLastSeen = new Date(0)

    get notifications() {
        return NotificationsModule.notifications
    }

    get sortedNotifications() {
        if (!this.notifications) {
            return []
        }

        const sortedNotifications = cloneDeep(this.notifications)
        sortedNotifications.sort((a: any, b: any) => {
            const aDate = new Date(a.createdAt)
            const bDate = new Date(b.createdAt)
            return bDate.getTime() - aDate.getTime()
        })
        return sortedNotifications
    }

    get inAppNotifications(): any {
        return this.sortedNotifications.filter((notification: any) => {
            return notification.notification.mode === 'In-app'
        })
    }

    get fiveNotifications() {
        return take(this.inAppNotifications, 15)
    }

    get unreadNotifications() {
        return this.fiveNotifications.filter((notification: any) => {
            const notDisplayed = notification.displayedAt === null
            const createdAfterLastseen =
                new Date(notification.createdAt) > this.notificationsLastSeen
            return notDisplayed && createdAfterLastseen
        })
    }

    get unreadNotificationsCount() {
        return this.unreadNotifications.length
    }

    calculateScrollState() {
        const top = window.pageYOffset || document.documentElement.scrollTop
        this.headerActive = top === 0 ? false : true
    }

    get opeUrlMore() {
        return this.ope ? this.ope.url : ''
    }

    async created() {
        window.addEventListener('scroll', this.calculateScrollState)

        await NotificationsModule.InitNotifications()

        await UserModule.Init()
        this.userID = UserModule.userInfos.id

        const resp = await this.apiService.getBuyerOperations(this.userID)
        const allOpe = resp.data
        this.allOpe = allOpe

        this.opeID = await getOperationID()
        if (this.opeID !== -1) {
            const opeResp = await this.apiService.getOperation(this.opeID)
            this.ope = opeResp.data
            this.opeSelected = this.ope.slug
        }

        document.addEventListener('click', this.onBodyClick)
    }

    /**
     * On masque la navbar si un clique survient
     */
    onBodyClick() {
        const $navbarSupportedContent: any = $(
            this.$refs.navbarSupportedContent
        )
        $navbarSupportedContent.collapse('hide')
    }

    mounted() {
        if (UserModule.token == undefined) {
            UserModule.Init()
        }
        this.name = nickname(
            UserModule.userInfos.firstname,
            UserModule.userInfos.lastname
        )

        /**
         * Utilisé pour fixer la hauteur du dropdown
         */
        this.computeWindowSize()

        window.addEventListener('resize', this.computeWindowSize)
        const link = <HTMLElement>this.$refs.notificationMenuLink
        const linkRect = link.getBoundingClientRect()
        const top = linkRect.top
        this.menuTop = top + link.offsetHeight

        this.restoreLocalStorage()

        const notificationsDropdown = this.$refs.notificationsDropdown as any
        this.$notificationsDropdown = $(notificationsDropdown) as any

        this.$notificationsDropdown.on(
            'show.bs.dropdown',
            this.onNotificationsDropdown
        )
    }

    restoreLocalStorage() {
        const notificationsLastSeenStr = localStorage.getItem(
            'notificationsLastSeen'
        )
        if (notificationsLastSeenStr) {
            this.notificationsLastSeen = new Date(notificationsLastSeenStr)
        }
    }

    @Watch('notificationsLastSeen')
    saveLocalStorage() {
        localStorage.setItem(
            'notificationsLastSeen',
            this.notificationsLastSeen.toString()
        )
    }

    onNotificationsDropdown() {
        this.notificationsLastSeen = new Date()
    }

    destroyed() {
        document.removeEventListener('click', this.onBodyClick)
        window.removeEventListener('resize', this.computeWindowSize)
        this.$notificationsDropdown.off(
            'show.bs.dropdown',
            this.onNotificationsDropdown
        )
    }

    computeWindowSize() {
        this.windowHeight = window.innerHeight
    }

    get maxMenuHeight() {
        const marginBottom = 20
        return this.windowHeight - this.menuTop - marginBottom + 'px'
    }

    logout() {
        UserModule.LogOut().then(response => {
            console.log(response)
            window.location.href = '/connexion?from=logout'
        })
    }

    showMessenger() {
        const FB = (window as any).FB
        FB.CustomerChat.showDialog()
    }

    @Watch('opeSelected')
    onOpeSelected() {
        const currentOpeSlug = getOperation()
        if (this.opeSelected === currentOpeSlug) {
            return
        }

        // if (this.opeSelected === 'DISCOVER_discover') {
        //     window.open('https://yvivre.com', '_blank')
        //     requestAnimationFrame(() => {
        //         this.opeSelected = currentOpeSlug
        //     })
        //     return
        // }

        if (this.opeSelected === 'DISCOVER_projets') {
            window.open('https://yvivre.com/projets/', '_blank')
            requestAnimationFrame(() => {
                this.opeSelected = currentOpeSlug
            })
            return
        }

        if (this.opeSelected === 'DISCOVER_concept') {
            window.open('https://yvivre.com/concept/', '_blank')
            requestAnimationFrame(() => {
                this.opeSelected = currentOpeSlug
            })
            return
        }

        if (this.opeSelected === 'DISCOVER_notice') {
            requestAnimationFrame(() => {
                this.opeSelected = currentOpeSlug
            })
            return
        }

        const appUrl = getAppUrl()
        const opeUrl = `http://${this.opeSelected}.${appUrl}`
        console.log(opeUrl)
        console.log(currentOpeSlug)
        window.open(opeUrl, '_blank')
        requestAnimationFrame(() => {
            this.opeSelected = currentOpeSlug
        })
    }
}
